<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">

          <div class="personal">

            <personal pageType="evaluation"></personal>
            <div class="personal_right">

              <h2  class="tit8 "><span><img src="../../../static/images/guide_sign4.png"> 我的评价列表</span></h2>
              <template>
                <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-left: 20px">
                  <el-tab-pane  label="办件评价"  name="first">
                    <div v-if="evaluation_list && evaluation_list.length>0">
                    <el-card class="box-card" shadow="hover"
                             style="width: 96%;margin-left: 0px;margin-top: 15px;font-size: 14px;"
                             v-for="(item,index) in evaluation_list" :key="index"
                    >
                      <div slot="header" class="clearfix">
                  <span>

                      <!-- <el-tag v-if="item.esStatus!='2'"
                               type="danger"
                               effect="dark" style="width: 55px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    待处理
                  </el-tag>
                       <el-tag  v-if="item.esStatus=='2'"

                                effect="dark" style="width: 55px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    已回复
                  </el-tag>-->
                    <span style="font-weight: 600">{{item.serviceName}}</span>
                    <!--<span style="font-weight: 600">{{item.applyNo}}</span>-->
                      </span>
                      </div>
                      <div class="text item" style="line-height: 27px;" >
                        <div style="display: flex;justify-content: left;">
                          <div style="width:300px;"><span class="yy_title1">受理单位：</span><span class="yy_title_content1">{{item.fromPartyName}}</span></div>
                          <div><span class="yy_title1">{{tabName}}日期：</span><span class="yy_title_content1">{{item.esTime}}</span></div>
                        </div>
                        <div style="display: flex;justify-content: left;">
                          <div><span class="yy_title1">{{tabName}}内容：</span><span class="yy_title_content1">{{item.peopleRemark}}</span></div>
                        </div>
                        <el-divider content-position="left" v-if="item.indexData && item.indexData.length>0">评分</el-divider>
                        <div v-for="(items, index) in item.indexData" :key="items.eiId"  style="display: flex;justify-content: left;line-height: 30px;">
                          <div class="yy_title1" >{{items.eiName}}:</div>
                          <div style="margin-left: 10px;">
                            <el-rate v-model="items.scores" :max="5" disabled style="margin-top: 5px;" show-text :texts="['极差','一般','合格','满意','优秀']"></el-rate>
                          </div>
                        </div>
                        <el-divider content-position="left" v-if="item.esStatus=='2'">办理回复</el-divider>
                        <div style="display: flex;justify-content: left;"  v-if="item.esStatus=='2'">
                          <div style="width:300px;"><span class="yy_title1">回复单位：</span><span class="yy_title_content1">{{item.fromPartyName}}</span></div>
                          <div><span class="yy_title1">回复时间：</span><span class="yy_title_content1">{{item.esReTime}}</span></div>
                        </div>
                        <div style="display: flex;justify-content: left;" v-if="item.esStatus=='2'">
                          <div><span class="yy_title1">回复内容：</span><span class="yy_title_content1">{{item.esRemark}}</span></div>
                        </div>
                      </div>
                    </el-card>
                    </div>
                    <div v-else>
                      <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                        <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                        <div>暂无数据</div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane  label="指南评价"  name="second">
                    <div v-if="guide_evaluation_list && guide_evaluation_list.length>0">
                    <el-card class="box-card" shadow="hover"
                             style="width: 96%;margin-left: 0px;margin-top: 15px;font-size: 14px;"
                             v-for="(item,index) in guide_evaluation_list" :key="index"
                    >
                      <div slot="header" class="clearfix">
                  <span>
                    <span style="font-weight: 600">{{item.value}}</span>
                    <span style="font-weight: 600">{{item.name}}</span>
                      </span>
                      </div>
                      <div class="text item" style="line-height: 23px;" >
                        <div style="display: flex;justify-content: left;">
                          <div><span class="yy_title1">{{tabName}}日期：</span><span class="yy_title_content1">{{item.last_time}}</span></div>
                        </div>
                        <div style="display: flex;justify-content: left;">
                          <div><span class="yy_title1">{{tabName}}内容：</span><span class="yy_title_content1">{{item.content}}</span></div>
                        </div>
                        <div style="display: flex;justify-content: left;line-height: 28px">
                          <div ><span class="yy_title1">评 &nbsp; &nbsp; &nbsp; 分:</span></div> <div style="margin-left: 10px;"><el-rate v-model="item.score" :max="5" disabled style="margin-top: 5px;" show-text :texts="['极差','一般','合格','满意','优秀']"></el-rate></div>
                        </div>
                      </div>
                    </el-card>
            </div>
            <div v-else>
              <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                <div>暂无数据</div>
              </div>
            </div>
                  </el-tab-pane>
                </el-tabs>
              </template>

            <!--  <table width="96%" border="0" cellspacing="0" cellpadding="0" class="personal_tab">
                <tr class="personal_tit">
                  <td width="14%">办事指南名称</td>
                  <td width="26%">评价内容</td>
                  <td width="20%">评价时间</td>
                  <td width="8%">评分</td>
&lt;!&ndash;                  <td width="16%">操作</td>&ndash;&gt;
                </tr>
                <tr v-for="(item,index) in evaluation_list" :key="index">
                  <td>{{item.serviceName}}</td>
                  <td>{{item.peopleRemark}}</td>
                  <td>{{item.esTime}}</td>
                  <td>{{`${item.score}分`}}</td>
&lt;!&ndash;                  <td class="per_button2"><a href="javascript:void(0)"><img src="../../../static/images/personal_sign1.png"> 详情</a> <a&ndash;&gt;
&lt;!&ndash;                    href="javascript:void(0)"><img src="../../../static/images/personal_sign2.png"> 删除</a></td>&ndash;&gt;
                </tr>
              </table>-->
              <div class="clear"></div>
              <div style="margin-top: 50px"></div>
            </div>


          </div>
        </div>


      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>

</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import personal from "../../components/Personal";

  export default {
    name: "Evaluation",
    components: {
      headers, fixedDiv, footers,personal
    },
    data() {
      return {
        evaluation_list: [],
        guide_evaluation_list: [],
        loginShow:false,
        gotoIndex:false,
        tabName:'',
        activeName: 'first',
        nowActiveName:'first',
      };
    },
    mounted() {
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
      }
      this.getListData();
    },
    methods: {
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      } ,
      handleClick(tab, event) {
        if(this.nowActiveName==tab.name){
          return;
        }
        this.nowActiveName=tab.name;
        if (tab.name=='first'){
         // this.urlTo('personal_evaluation')
          this.getListData();
        }else{
          ///this.urlTo('personal_guide_evaluation')
          this.getGuideListData();
        }

        console.log(tab, event);
      },

      getListData() {
        this.$https.post("/api/apply/getApplyEvaluationScoreList.do", {}, response => {
          if (response.status === 200 && response.data.code === 200) {
            if (!this.$util.isEmpty(response.data.data)) {
              this.evaluation_list = response.data.data;
              this.tabName='评价';
            }
          }
        });
      },
      getGuideListData() {
        this.$https.post("/api/apply/getGuideEvaluation.do", {}, response => {
          if (response.status === 200 && response.data.code === 200) {
            if (!this.$util.isEmpty(response.data.data)) {
              this.guide_evaluation_list = response.data.data;
              this.tabName='评价';
            }
          }
        });
      }
    }
  }
</script>

<style>
  .yy_title1{
    font-size: 14px;
  }
  .yy_title_content1{
    font-size: 13px;
    color: #909399;
  }
</style>



// WEBPACK FOOTER //
// src/pages/personal/Evaluation.vue